import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'AltafiberTheme',
  code: 'cincinnatibell',
  colors: {
    headerBackground: '#fff',
    headerText: '#212529',
    headerBorder: '#e0e7e9',
    background: '#FFFFFF',
    footerBackground: '#f2f2f2',
    footerText: '#8c8c8c',
    footerBorder: '#e0e7e9',
    progressBar: '#3957E1',
  },
  logoSize: {
    width: '195px',
    height: '48px',
  },
  baseColors: {
    link: '#012639',
    cta: '#012639',
    hover: '#012639',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const AltafiberTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
